import { FrequentlyAskedQuestionSection } from './view';
export default FrequentlyAskedQuestionSection;
